import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslocoCoreModule } from "@i18n";
import { FuseScrollbarModule } from "@nx-workspace/fuse";
import { ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatDialogModule } from "@angular/material/dialog";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatDividerModule } from "@angular/material/divider";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatRadioModule } from "@angular/material/radio";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { IMaskModule } from "angular-imask";
import { DateRangePickerComponent } from "./date-range-picker.component";
import { RangePickerComponent } from "./range-picker.component";

@NgModule({
    declarations: [DateRangePickerComponent, RangePickerComponent],
    imports: [
        CommonModule,

        // form
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        MatIconModule,

        // material
        MatProgressBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatOptionModule,
        MatTableModule,
        MatDialogModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatDividerModule,
        MatButtonToggleModule,
        MatSortModule,
        MatRadioModule,
        MatProgressSpinnerModule,

        IMaskModule,

        // i18n
        TranslocoCoreModule,

        // fuse
        FuseScrollbarModule,
    ],
    exports: [DateRangePickerComponent],
})
export class DateRangePickerModule {}
